import { useQuery } from "@tanstack/react-query";

type PreviewListPager = {
    total: number;
    total_page: number;
    last_page: number;
    per_page: number;
    current_page: number;
};

export type PreviewListData<T> = Array<T> & {
    pager: PreviewListPager;
    active_filters: HashMap<unknown>;
};

type PreviewListFetcher<T> = (params?: HashMap<unknown>) => Promise<PreviewListData<T>>;

/**
 * Fetches a short preview list with fixed params (subcategory pages, embedded sections).
 * Unlike ListProvider, does not merge URL query params or static cache.
 *
 * `refetchOnMount: "always"` ensures previews stay fresh when navigating back to the page,
 * even if the query is already in cache from a previous visit.
 */
export function usePreviewList<T>(dataFetcher: PreviewListFetcher<T>, params: HashMap<unknown>, queryKey: string) {
    return useQuery({
        queryKey: ["preview-list", queryKey, params],
        queryFn: () => dataFetcher(params),
        refetchOnMount: "always",
    });
}
